import { AsyncRequestResponse } from '@/modules/core/api/models/AsyncRequestResponse';
import { Route } from '@/modules/core/app/constants/api.constants';
import { AxiosResponse } from '@/modules/core/app/models/AxiosResponse';
import { BaseResourceService } from '@/modules/core/app/services/abstracts/BaseResourceService';

export class AsyncRequestResponseService extends BaseResourceService {
  getRoute(): string {
    return Route.JOBS_ASYNSREQUESTRESPONSE;
  }

  getModel(): typeof AsyncRequestResponse {
    return AsyncRequestResponse;
  }

  async getRequestResponse(
    requestId: string,
    responseType: string
  ): Promise<AsyncRequestResponse | AxiosResponse> {
    return this.resource.get(this.getRoute(), {
      params: { requestId },
      responseType
    });
  }
}

export default new AsyncRequestResponseService();
